import { hashString } from './hashString.es.js';

const createUniqueClassName = (block, elementName) => {
  const hash = hashString("design-system" + block + elementName);
  return `${block}__${elementName}-${hash}`;
};

export { createUniqueClassName };
//# sourceMappingURL=createUniqueClassName.es.js.map
